import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> "Flipfoot" Flipbook </h1>

    
    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/flipfootGrid.png')} data-skip-gallery/>
        </div>
    </div>

    
    <p>"Flipfoot" is a flipbook rendition of a health condition I experienced, created 
    as my final project in the course <a target="_blank" href={require('../assets/graphicDesign/artBio_syllabus.pdf')}>60-358</a>, "Art and Biology". In 
    2015, I sustained a stress fracture of the fibular sesamoid in my right foot. 
    While aware this was a "slow-healing" bone, I was unprepared for the other physical 
    problems that would arise as a result of this injury.</p>

    <p>Over the 6 months following the fracture, I developed Complex Regional 
    Pain Syndrome (CRPS) due to the injury. The NIH defines CRPS as a nervous system 
    syndrome that can include changes in skin texture, stiffness in affected joints, 
    problems coordinating muscle movement, changes in temperature and skin color, 
    and swelling of the affected limb. In experiencing these symptoms, I became 
    anxious about the health of my injured foot.</p>

    <p>Upon research, I could not find connections between my injury and CRPS. It is 
    important to create this teaching tool because patients who better understand 
    their medical problems tend to have less stress, heal better and faster, and follow 
    their doctor's instructions. With this goal in mind, I researched the anatomy of the 
    foot and began drawing, reviewing my illustrations with my podiatrist and Stanford 
    Medical School's medical illustrator. Lastly, I chose the format of a flipbook because 
    physical interaction has been shown to strengthen learning and memory.</p>

    <p>Injuries are not stagnant. Everything in the body is connected.</p>

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.